var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M17.854 6.424c-.943 0-1.708.76-1.708 1.697s.765 1.697 1.708 1.697 1.707-.76 1.707-1.697-.764-1.697-1.707-1.697m-3.964.485A4.145 4.145 0 0 1 17.854 4C20.144 4 22 5.845 22 8.121s-1.856 4.121-4.146 4.121a4.145 4.145 0 0 1-3.964-2.909H3.22C2.546 9.333 2 8.791 2 8.121S2.546 6.91 3.22 6.91zm-7.744 7.273c-.943 0-1.707.76-1.707 1.697s.764 1.697 1.707 1.697 1.708-.76 1.708-1.697-.765-1.697-1.708-1.697M2 15.879c0-2.276 1.856-4.121 4.146-4.121a4.145 4.145 0 0 1 3.964 2.909h10.67c.674 0 1.22.542 1.22 1.212s-.546 1.212-1.22 1.212H10.11A4.145 4.145 0 0 1 6.146 20C3.856 20 2 18.155 2 15.879",
    clipRule: "evenodd"
  })));
};
export default SvgFilter;